export default {
  sipParams(state) {
    return state.sipParams
  },
  sipHistory(state) {
    return state.sipHistory
  },
  incomingUser(state) {
    return state.incomingUser
  },
  outgoingUser(state) {
    return state.outgoingUser
  },
  sipParam(state) {
    return state.sipParam
  },
  incomingCall(state) {
    return state.isIncomingCall
  },
  modalOpen(state) {
    return state.isModalOpen
  },
  openedSession(state) {
    return state.isOpenedSession
  },
  inCall(state) {
    return state.isInCall
  },
  phone(state) {
    return state.phone
  },
  incomingPhone(state) {
    return state.incomingPhone
  },
  sipHistoryComments(state) {
    return state.sipHistoryComments
  },
  isCommentsLoaded(state) {
    return state.isCommentsLoaded
  },
}
